import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Navigation, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { axiosRequest } from "../../api";
import { baseURL, ADMINURL } from "../../constant";
import ReactHtmlParser from "react-html-parser";
import Cookies from "universal-cookie";
import moment from "moment/moment";

/*import { Link } from "react-router-dom";
import { Navigation, Autoplay  } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import BrandsSection from "../common/brands";*/

function Home() {
  const [loading, setLoading] = useState(false);
  const [posts, setPosts] = useState([]);
  const [homecontent, setHomeContent] = useState([]);
  const [apiCalled, setApiCalled] = useState(false);

  const cookies = new Cookies();
    let checkLogin = cookies.get("islogin");
    const userEmail = cookies.get("userEmail");
    const userName = cookies.get("userName");
    
const logout = () => {
    const deleteAllCookies = () => {
        const cookies = document.cookie.split(";");

        cookies.forEach((cookie) => {
            const name = cookie.split("=")[0].trim();
            if (name !== 'setting') {
              document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            }
        });
    };

  // Clear cookies and perform other logout tasks
    deleteAllCookies();
    cookies.remove("islogin");
    cookies.remove("loginSuccess");
    cookies.remove("comeFrom");
    cookies.remove("userId");
    cookies.remove("userEmail");
    cookies.remove("email");
    cookies.remove("userName");
    window.location.reload();
  };
  useEffect(() => {
    cookies.set("serviceType", '1');
    const loadPost = async () => {
      // Till the data is fetch using API
      // the Loading page will show.
      setLoading(true);
      // Await make wait until that
      // promise settles and return its result
      const response = await axiosRequest.get(`${baseURL}/slider`);

      // After fetching data stored it in posts state.
      setPosts(response.data);

      // Closed the loading page
      setLoading(false);
    };

    // Call the function
    loadPost();
  }, []);

  useEffect(() => {
    const loadPost = async () => {
      // Till the data is fetch using API
      // the Loading page will show.
      setLoading(true);
      // Await make wait until that
      // promise settles and return its result
      const response = await axiosRequest.get(`${baseURL}/homecontent`);

      // After fetching data stored it in posts state.
      setHomeContent(response.data);

      // Closed the loading page
      setLoading(false);
    };

    // Call the function
    loadPost();
  }, []);

  const [taxAmount, settaxAmount] = useState("0.00");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const config = {
    headers: { "content-type": "multipart/form-data" },
  };
  const [files, setFileName] = useState("");
  const [isFile, setIsFile] = useState("");

  const onFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const selectedFiles = Array.from(e.target.files); // Convert FileList to an Array

      setFileName((prevFiles) => [...prevFiles, ...selectedFiles]); // Add new files to state


      console.log(e.target.files);
     // setFileName(e.target.files[0]);
      setIsFile([...e.target.files]);
    }
  };
  // Remove a file from the list
  const handleRemoveFile = (indexToRemove) => {
    setIsFile((files) =>
      files.filter((_, index) => index !== indexToRemove)
    );
    setFileName((files) =>
      files.filter((_, index) => index !== indexToRemove)
    );
  };

  const data = {
    name: name,
    files: files,
    email: email,
  };
  let handleSubmit = async (e) => {

    setLoading(true);
    
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", name)
    formData.append("email", email)
    if(files){
      files.forEach((filesin) => formData.append("files[]", filesin));
    }
    

    await axiosRequest
      .post(`${baseURL}/submitQuoteSampleJob`, formData, config)
      .then((response) => {
        console.log(response);
        if (response.data.success === true) {
          setName("");
          setEmail("");
          setFileName("");
          setIsFile("");
          setMessage(response.data.message);
          setLoading(false);
        } else {
          setMessage(response.data.message);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Function to calculate the next day's date
  // const getNextDayDate = () => {
  //   const currentDate = new Date();
  //   currentDate.setDate(currentDate.getDate() + 2); // Add one day to the current date
  //   const year = currentDate.getFullYear();
  //   const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Month is 0-based
  //   const day = String(currentDate.getDate()).padStart(2, "0");
  //   return `${day}-${month}-${year}`;
  // };
  // const [deliverydate, setDeliverydate] = useState(getNextDayDate());
  const [deliverydate, setDeliverydate] = useState();

  // const [deliverydate, setDeliverydate] = useState("30-07-2023");
  const [wordlength, setWordlength] = useState("250");
  const [price, setPrice] = useState("12.5");
  
  //const formdata = 'aaa';
  const handleChange = (event) => {
    cookies.set("serviceType", event.target.value, { path: "/" });
      //this.setState({ jobType: event.target.value });

       
      axiosRequest
      .get(
        `${baseURL}/getPriceForWordcountServiceType/`+wordlength+'/'+event.target.value
      )
      .then(function (response) {
        
        let pp = response.data.amountQuoted;
        let currency = response.data.currency;
        let ratio = response.data.ratio;
        let editorFees = response.data.editorFee;
        //for the last 2 decimal
      pp = pp;
      console.log(pp);
      setPrice(pp, ratio, editorFees);
      setWordlength(wordlength);
      cookies.set("wordlength", wordlength, { path: "/" });
      cookies.set("currency", currency, { path: "/" });
      cookies.set("rcurrency", currency, { path: "/" });
      cookies.set("price", pp, { path: "/" });
      cookies.set("firstQuoteprice", pp, { path: "/" });
      cookies.set("ratio", ratio, { path: "/" });
      cookies.set("editorFees", editorFees, { path: "/" });
      cookies.set("homePrice", pp, { path: "/" });
        
      })
      .catch(function (error) {
        console.log(error);
      });
      
    // setDeliverydate(event.target.value);
    // 👇 Get input value from "event"
    if (event.target.value == 1) {
      //  setDeliverydate('30-07-2023');
      // let d = new Date();
      //  d.setTime(d.getTime() + (99*60*1000));
      //cookies.set('deliverydate', deliverydate, { path: '/' });
       cookies.set("jobType", 'Basic Service', { path: "/" });

       // Cookies.set('deliverydate', deliverydate, { expires: 7 });
    } else if (event.target.value == 2) {
      cookies.set("jobType", 'Plus Service', { path: "/" });
      //  Cookies.set('deliverydate', deliverydate, { expires: 7 });
      // cookies.set('deliverydate', deliverydate, { path: '/' });
      //  setDeliverydate('05-08-2023');
    } else {
      // Cookies.set('deliverydate', deliverydate, { expires: 7 });
      //  cookies.set('deliverydate', deliverydate, { path: '/' });
      //  setDeliverydate('10-08-2023');
    }
  };
  useEffect(() => {
    
    axiosRequest
    .get(
      `${baseURL}/getPriceForWordCount/250`
    )
    .then(function (response) {
      
      let pp = response.data.amountQuoted;
      let currency = response.data.currency;
      let ratio = response.data.ratio;
      let editorFees = response.data.editorFee;
      //for the last 2 decimal
    pp = pp;
    console.log(pp);
    setPrice(pp, ratio, editorFees);
    setWordlength(250);
    cookies.set("wordlength", 250, { path: "/" });
    cookies.set("currency", currency, { path: "/" });
    cookies.set("rcurrency", currency, { path: "/" });
    cookies.set("price", pp, { path: "/" });
    cookies.set("firstQuoteprice", pp, { path: "/" });
    cookies.set("ratio", ratio, { path: "/" });
    cookies.set("editorFees", editorFees, { path: "/" });
    cookies.set("homePrice", pp, { path: "/" });

      if(currency ==1){
          const price = cookies.get('price');
      const tax  = (price*10)/100;
      console.log("Tax Am%="+tax);
      cookies.set("taxvalue", tax, { path: "/" });
      this.settaxAmount(tax);
      }else{
        cookies.set("taxvalue", '0', { path: "/" });
      }
     
    })
    .catch(function (error) {
      console.log(error);
    });

    axiosRequest
      .get(`${baseURL}/getMaxDateBeforeExpedited/250/UTC`)
      .then(function (response) {
        const formattedDeliveryDate = moment(response.data).format(
          "DD MMM YYYY"
        );
        setDeliverydate(formattedDeliveryDate);
        cookies.set("deliverydate", response.data, { path: "/" });
      })
      .catch(function (error) {});
    const loadSetting = async () => {
      const response = await axiosRequest.get(`${baseURL}/getsetSetting`);
      cookies.set("setting", response.data, { path: "/" });
    };

    cookies.set("wordlength", "250", { path: "/" });
    cookies.set("firstQuoteprice", "12.5", { path: "/" });
    cookies.set("price", "12.5", { path: "/" });
    cookies.set("selected", 1, { path: "/" });
    cookies.set("editorFees", "5", { path: "/" });
    cookies.set("ratio", "1", { path: "/" });
    cookies.set("jobType", "Basic Service", { path: "/" });
    loadSetting();
  }, []);
  
   const handleCalculateClick = async () => {
        const serviceType = cookies.get('serviceType'); 
        const wordlength = cookies.get('wordlength');
        const wordCount = cookies.get('wordlength');
        let pp;
    let ratio;
    let editorFees; 

    try {
     
        axiosRequest
        .get(
          `${baseURL}/getPriceForWordcountServiceType/` + wordlength + `/`+serviceType
        ) 
        .then(function (response) {
          console.log(response.data.amountQuoted);
          if(response.data.amountQuoted){
              pp = response.data.amountQuoted;
              ratio = response.data.ratio;
              editorFees = response.data.editorFee;
                //for the last 2 decimal
            
              
              setPrice(pp, ratio, editorFees);
              setWordlength(wordCount);
              cookies.set("wordlength", wordCount, { path: "/" });
              cookies.set("price", pp, { path: "/" });
              cookies.set("firstQuoteprice", pp, { path: "/" });
              cookies.set("ratio", ratio, { path: "/" });
              cookies.set("editorFees", editorFees, { path: "/" });
              cookies.set("homePrice", pp, { path: "/" });
              const currency  =  cookies.get('currency');
              if(currency ==1){
                const price = cookies.get('price');
                const tax  = (price*10)/100;
                console.log("Tax Am%="+tax);
                cookies.set("taxvalue", tax, { path: "/" });
                this.settaxAmount(tax);
              }else{
                cookies.set("taxvalue", '0', { path: "/" });
              }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
        
        
        // loadDelevirydate();
        axiosRequest
          .get(
            `${baseURL}/getMaxDateBeforeExpedited/` + wordlength + `/UTC`
          )
          .then(function (response) {
            const formattedDeliveryDate = moment(response.data).format(
              "DD MMM YYYY HH:mm"
            );
            setDeliverydate(formattedDeliveryDate);
            cookies.set("deliverydate", response.data, { path: "/" });
            setApiCalled(true);
          })
          .catch(function (error) {
            console.log(error);
          });

    } catch (error) {
      console.error('API Error:', error);
    }
  };

  const handleChangeText = (event) => {
     setApiCalled(false);
    cookies.set("wordlength", event.target.value, { path: "/" });
    const serviceType = cookies.get('serviceType'); 
    setWordlength(event.target.value);
    const wordCount = event.target.value;
   
    /*
    let pp;
    let ratio;
    let editorFees;

    axiosRequest
    .get(
      `${baseURL}/getPriceForWordcountServiceType/` + event.target.value + `/`+serviceType
    ) 
    .then(function (response) {
      console.log(response.data.amountQuoted);
      if(response.data.amountQuoted){
           pp = response.data.amountQuoted;
           ratio = response.data.ratio;
           editorFees = response.data.editorFee;
            //for the last 2 decimal
         
          
          setPrice(pp, ratio, editorFees);
          setWordlength(wordCount);
          cookies.set("wordlength", wordCount, { path: "/" });
          cookies.set("price", pp, { path: "/" });
          cookies.set("firstQuoteprice", pp, { path: "/" });
          cookies.set("ratio", ratio, { path: "/" });
          cookies.set("editorFees", editorFees, { path: "/" });
          cookies.set("homePrice", pp, { path: "/" });
          const currency  =  cookies.get('currency');
          if(currency ==1){
            const price = cookies.get('price');
            const tax  = (price*10)/100;
            console.log("Tax Am%="+tax);
            cookies.set("taxvalue", tax, { path: "/" });
            this.settaxAmount(tax);
          }else{
            cookies.set("taxvalue", '0', { path: "/" });
          }
      }
    })
    .catch(function (error) {
      console.log(error);
    });
    
    
    // loadDelevirydate();
    axiosRequest
      .get(
        `${baseURL}/getMaxDateBeforeExpedited/` + event.target.value + `/UTC`
      )
      .then(function (response) {
        const formattedDeliveryDate = moment(response.data).format(
          "DD MMM YYYY HH:mm"
        );
        setDeliverydate(formattedDeliveryDate);
        cookies.set("deliverydate", response.data, { path: "/" });
      })
      .catch(function (error) {
        console.log(error);
      });
      */
  };
  // const datestr = deliverydate;
  // console.log(new Date(datestr).toISOString(), 182);

  // useEffect(() => {
  //   // Parse the current date string using the provided format
  //   const parsedDate = moment(deliverydate, "ddd MMM DD YYYY HH:mm:ss ZZ");
  //   console.log(parsedDate.format("DD MMM YYYY HH:mm "));

  //   // Format the parsed date to the desired format
  //   const formattedDate = parsedDate.format("DD MMM YYYY HH:mm");

  //   console.log(171, formattedDate); // Output the formatted date to the console
  // }, [deliverydate]);

  return (
    <>
      <section className="banner-section">
        <div
          id="carouselExampleCaptions"
          className="carousel slide"
          data-ride="carousel"
        >
          {/* <ol className="carousel-indicators">
                    <li data-target="#carouselExampleCaptions" data-slide-to="0" className="active"></li>
                    <li data-target="#carouselExampleCaptions" data-slide-to="1"></li>                  
                  </ol> */}

          <div className="carousel-inner">
            {loading ? (
              <h4>Loading...</h4>
            ) : (
              posts.map((item, i) => (
                <>
                  <div className={`carousel-item ${i === 1 && "active"}`}>
                    <img
                      src={ADMINURL + item.image}
                      className="d-block w-100"
                      alt=" "
                    />
                  </div>
                </>
              ))
            )}
          </div>
          <div
            className="carousel-control-prev"
            data-target="#carouselExampleCaptions"
            data-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="sr-only">Previous</span>
          </div>
          <div
            className="carousel-control-next"
            data-target="#carouselExampleCaptions"
            data-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="sr-only">Next</span>
          </div>
        </div>

        <div className="instant-quote">
          <div className="container">
            <div className="row justify-content-start">
              <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="quote-form" id="quote-form">
                  <h4>
                    Instant <span>Quote</span>
                  </h4>
                  <div className="row">
                    <div className="col-md-6 col-sm-12 col-12">
                      <div className="form-group">
                        <label>Service Type</label>
                        <select
                          className="form-control"
                          onChange={handleChange}
                        >
                          <option value="1" selected>
                            Proofreading
                          </option>
                          <option value="2">Editing</option>
                         
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12 col-12">
                      <div className="form-group">
                        <label>Delivery Date</label>
                        <input
                          type="text"
                          className="form-control"
                          value={deliverydate}
                          disabled
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12 col-12">
                      <div className="form-group">
                        <label>Length (Number of Words)</label>
                        <input
                          type="number"
                          value={wordlength}
                          className="form-control"
                          placeholder="1100 words"
                         onChange={handleChangeText}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12 col-12">
                      <div className="btn-main-box">
                        <div className="form-group">
                          <label>Price</label>
                          <span>${price}</span>
                        </div>

                        <div className="btn-box">
                          {checkLogin == "false"  || !checkLogin   && (
                          <>
                           {!apiCalled && (
                          <button
                            deliverydate={deliverydate}
                           
                            className="btn btn-dark"
                            onClick={handleCalculateClick}
                          >
                            Get Quote
                          </button>
                           )}
                           {apiCalled && (
                          <Link
                            deliverydate={deliverydate}
                            to={{
                              pathname: "/quote",
                              state: { id: 1, name: "sabaoon", shirt: "green" },
                            }}
                            className="btn btn-dark"
                          >
                            Get Started
                          </Link>
                           )}
                          </>
                          )}
                          {checkLogin == "true" && (
                              <a className="btn btn-dark" href="#" onClick={() =>
                                        window.location.replace(
                                          `https://staging.wordsru.com/backend/login?email=${userEmail}&login=1`
                                        )
                                      }>Get Started</a>
                              
                                  
                                  )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Get free sample form section start here */}
      <section className="getform-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="below-banner">
                <div className="imageslist">
                  <ul>
                    <li>Excellent</li>
                    <li>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/star-review.png"
                        }
                        alt=""
                      />
                    </li>
                    <li>
                      <img
                        src={
                          process.env.PUBLIC_URL + "/assets/images/shoppers.png"
                        }
                        alt=""
                      />
                    </li>
                  </ul>
                </div>
                <div className="getform-box">
                  <div className="row">
                    <div className="col-md-8 col-sm-12 col-12">
                      <h3>{ReactHtmlParser(homecontent.form_title)}</h3>
                    </div>
                    <div className="col-md-4 col-sm-12 col-12 text-lg-right">
                      <Link to="/get-free-sample" className="btn-custom">
                        Free sample available for jobs
                      </Link>
                    </div>
                  </div>
                  {loading ? (
                      <div id="loading">
                        <div id="loader"></div>
                      </div> // Show loader when loading is true
                  ) : (
                      ' '
                  )}
                  <form onSubmit={handleSubmit} enctype="multipart/form-data">
                    <div className="row mt-4">
                      <div className="col-3">
                        <div className="form-group">
                          <label>Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            placeholder="Your Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="form-group">
                          <label>Email</label>
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            placeholder="Email Address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="form-group">
                          <label className="upload-label">
                            Upload file
                          </label>
                          <input
                            className="upload"
                            multiple
                            type="file"
                            onChange={onFileChange}
                          />
                          <div className="mt-3">
                            {isFile.length > 0 && (
                              <ul>
                                {isFile.map((files, index) => (
                                  <li className="text-green" key={index}> {files.name} &nbsp; <a className="text-red" 
                                  onClick={(e) => {
                                    e.preventDefault(); // Prevent default action
                                    handleRemoveFile(index);
                                  }}
                                  href="#">Remove</a></li>
                                ))}
                              </ul>
                            )}
                          </div>
                           
                        </div>
                      </div>
                      <div className="col-2">
                         {checkLogin == "false"  || !checkLogin  && (
                        <button
                          type="submit"
                          className="btn btn-dark rounded-0 w-100"
                        >
                          Submit
                        </button>
                         )}
                        {checkLogin == "true" && (
                              <a className="btn btn-dark rounded-0 w-100" href="#" onClick={() =>
                                        window.location.replace(
                                          `https://staging.wordsru.com/backend/login?email=${userEmail}&login=1`
                                        )
                                      }>Submit</a>
                              
                                  
                                  )}
                      </div>
                    </div>
                  </form>
                  <div className="message">
                    {message ? <p>{message}</p> : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Get free sample form section start here */}

      {/* Professional Editing & Proofreading Services section start here */}
      <section className="section-padding">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <div className="section_title">
                <h3> {ReactHtmlParser(homecontent.services_title)}</h3>
              </div>
            </div>
            <div className="col-12 text-center mb-4">
              {ReactHtmlParser(homecontent.services_description)}
            </div>

            <div className="col-md-4 col-sm-12 col-12">
              <div className="service_box">
                <div className="icon-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-graduation-cap"></i>
                  </div>
                  <h4>Academic Editing</h4>
                </div>
                <div className="content">
                  <p>
                    WordsRU can assist you with editing a variety of academic and scholarly documents to meet university standards.
                  </p>
                  <ul>
                    <li>
                      <i className="fa-solid fa-check-circle"></i>Research Papers
                    </li>
                    <li>
                      <i className="fa-solid fa-check-circle"></i>Essays & Reports
                    </li>
                    <li>
                      <i className="fa-solid fa-check-circle"></i>Master's Theses
                    </li>
                    <li>
                      <i className="fa-solid fa-check-circle"></i>Journal Articles
                    </li>
                    <li>
                      <i className="fa-solid fa-check-circle"></i>PhD Dissertations
                    </li>
                  </ul>
                </div>
                <Link onClick={() => {
  const element = document.getElementById('quote-form');
  element?.scrollIntoView({
    behavior: 'smooth'
  }); 
}}  className="getquote">
                  Get Quote <i className="fa-solid fa-arrow-right mr-2"></i>
                </Link>
              </div>
            </div>

            <div className="col-md-4 col-sm-12 col-12">
              <div className="service_box">
                <div className="icon-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-briefcase"></i>
                  </div>
                  <h4>Business & Creative</h4>
                </div>
                <div className="content">
                  <p>
                    Ensure your professional brand and creative works reflect the highest quality with our expert business editors.
                  </p>
                  <ul>
                    <li>
                      <i className="fa-solid fa-check-circle"></i>Books & Manuscripts
                    </li>
                    <li>
                      <i className="fa-solid fa-check-circle"></i>Company Documents
                    </li>
                    <li>
                      <i className="fa-solid fa-check-circle"></i>Web Contents
                    </li>
                    <li>
                      <i className="fa-solid fa-check-circle"></i>Blogposts & Articles
                    </li>
                    <li>
                      <i className="fa-solid fa-check-circle"></i>CVs & Resumes
                    </li>
                  </ul>
                </div>
                <Link onClick={() => {
  const element = document.getElementById('quote-form');
  element?.scrollIntoView({
    behavior: 'smooth'
  }); 
}} className="getquote">
                  Get Quote <i className="fa-solid fa-arrow-right mr-2"></i>
                </Link>
              </div>
            </div>

            <div className="col-md-4 col-sm-12 col-12">
              <div className="service_box">
                <div className="icon-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-check"></i>
                  </div>
                  <h4>Comprehensive Checks</h4>
                </div>
                <div className="content">
                  <p>
                    Every document undergoes a rigorous checking process to ensure total accuracy and stylistic perfection.
                  </p>
                  <ul>
                    <li>
                      <i className="fa-solid fa-check-circle"></i>Grammar & Spelling
                    </li>
                    <li>
                      <i className="fa-solid fa-check-circle"></i>Sentence Structure
                    </li>
                    <li>
                      <i className="fa-solid fa-check-circle"></i>Australian English (AU)
                    </li>
                    <li>
                      <i className="fa-solid fa-check-circle"></i>Punctuation & Formatting
                    </li>
                    <li>
                      <i className="fa-solid fa-check-circle"></i>Style & Tone Consistency
                    </li>
                  </ul>
                </div>
                <Link onClick={() => {
  const element = document.getElementById('quote-form');
  element?.scrollIntoView({
    behavior: 'smooth'
  }); 
}}  className="getquote">
                  Get Quote <i className="fa-solid fa-arrow-right mr-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Professional Editing & Proofreading Services section end here */}

      {/* CTA Section Start */}

      <section className="cta-section">
        <div className="container">
          <div className="cta-box">

            <h2>Quick and affordable proofreading services available 24/7</h2>

            <p>
              No matter the time zone or the deadline, our global team is ready to assist you.
              Experience the gold standard of Australian editing services.
            </p>

            <div className="cta-actions">

              <a href="mailto:chiefeditor@wordsru.com" className="cta-email">
                <i className="fa-solid fa-envelope"></i>
                chiefeditor@wordsru.com
              </a>

              <div className="cta-availability">
                <i className="fa-regular fa-clock"></i>
                Always available, 24/7/365
              </div>

            </div>

          </div>
        </div>
      </section>

      {/* CTA Section End */}

      {/* Process Section Start */}

      <section className="process-section section-padding">
        <div className="container">

          <div className="text-center mb-5">
            <h2 className="process-title">
              Put your <span>best</span> words forward
            </h2>

            <p className="process-subtitle">
              Improve your results by collaborating with our professional editors.
              Follow these steps to receive your quality edit today!
            </p>
          </div>

          <div className="row text-center process-steps">

            <div className="col-md-2 col-sm-4 col-6">
              <div className="step-box">
                <div className="step-icon">
                  <i className="fa-solid fa-cloud-arrow-up"></i>
                </div>
                <h5>UPLOAD</h5>
                <p>Upload your documents and provide your word count, deadline, and requirements.</p>
              </div>
            </div>

            <div className="col-md-2 col-sm-4 col-6">
              <div className="step-box">
                <div className="step-icon">
                  <i className="fa-solid fa-credit-card"></i>
                </div>
                <h5>PAYMENT</h5>
                <p>Our payment methods, Stripe and Paypal, guarantee your secure payment.</p>
              </div>
            </div>

            <div className="col-md-2 col-sm-4 col-6">
              <div className="step-box">
                <div className="step-icon">
                  <i className="fa-solid fa-pen"></i>
                </div>
                <h5>EDITOR</h5>
                <p>Your job will be assigned to the most suitable editor for your field.</p>
              </div>
            </div>

            <div className="col-md-2 col-sm-4 col-6">
              <div className="step-box">
                <div className="step-icon">
                  <i className="fa-solid fa-comments"></i>
                </div>
                <h5>COLLABORATE</h5>
                <p>Message your editor anytime. <br/>We encourage collaboration for better results.</p>
              </div>
            </div>

            <div className="col-md-2 col-sm-4 col-6">
              <div className="step-box">
                <div className="step-icon">
                  <i className="fa-solid fa-check"></i>
                </div>
                <h5>DELIVERY</h5>
                <p>You will receive your edited documents by the deadline or earlier.</p>
              </div>
            </div>

            <div className="col-md-2 col-sm-4 col-6">
              <div className="step-box">
                <div className="step-icon">
                  <i className="fa-solid fa-thumbs-up"></i>
                </div>
                <h5>FEEDBACK</h5>
                <p>Your feedback helps us to help you! We value your experience.</p>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Process Section End */}

      {/* Editor + Stats Section Start */}

      <section className="editor-stats-section">
        <div className="container">
          <div className="row align-items-center">

            {/* LEFT SIDE - EDITOR PROFILE */}

            <div className="col-lg-6 editor-profile">

              <div className="editor-avatar">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/carol.png"}
                  alt="Editor"
                />
              </div>

              <div className="editor-content">

                <h3>
                  <span>Carole</span>, Editor
                </h3>

                <p>
                  Carole has been a freelance editor for years. She has edited countless
                  novels, as well as numerous dissertations, research papers, journal
                  articles, and websites.
                </p>

                <p>
                  In addition, she is the author of several novels. Carole has a BS in
                  Mathematics, a BA in French, and an MS in Education.
                </p>

                <a href="#" className="read-more">Read more</a>

              </div>

            </div>

            {/* RIGHT SIDE - STATS */}

            <div className="col-lg-6">

              {/* ROW 1 */}
              <div className="row stats-row-top">

                <div className="col-md-6 stat-box large">
                  <i className="fa-regular fa-file"></i>
                  <span>PAGES EDITED</span>
                  <h2>554 015</h2>
                </div>

                <div className="col-md-6 stat-box large">
                  <i className="fa-regular fa-hourglass"></i>
                  <span>JOBS IN PROGRESS</span>
                  <h2>65</h2>
                </div>

              </div>


              {/* ROW 2 */}
              <div className="row stats-row-bottom">

                <div className="col-md-4 stat-box small">
                  <i className="fa-solid fa-globe"></i>
                  <span>COUNTRIES</span>
                  <h3>147</h3>
                </div>

                <div className="col-md-4 stat-box small">
                  <i className="fa-regular fa-circle-check"></i>
                  <span>JOBS COMPLETED</span>
                  <h3>25 679</h3>
                </div>

                <div className="col-md-4 stat-box small">
                  <i className="fa-solid fa-users"></i>
                  <span>EDITORS AVAILABLE</span>
                  <h3>20</h3>
                </div>

              </div>

            </div>
          </div>
        </div>
      </section>

      {/* Editor + Stats Section End */}
      
      {/* Final CTA Section Start */}

      <section className="final-cta-section">

        <div className="container text-center">

          <div className="cta-badge">
            We edit for results
          </div>

          <div className="row justify-content-center features-row">

            <div className="col-md-4">
              <div className="feature-box">
                <div className="feature-icon">
                  <i className="fa-regular fa-clock"></i>
                </div>

                <p>
                  <span>Fast</span> proofreading and editing,
                  deadline guaranteed
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="feature-box">
                <div className="feature-icon">
                  <i className="fa-regular fa-pen-to-square"></i>
                </div>

                <p>
                  <span>Free sample</span> edit with your first job.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="feature-box">
                <div className="feature-icon">
                  <i className="fa-regular fa-comment"></i>
                </div>

                <p>
                  Check out <span>feedback</span> given by real
                  WordsRU customers!
                </p>
              </div>
            </div>

          </div>

          <div className="quote-button">
            <button
              onClick={() => {
                const element = document.getElementById("quote-form");
                element?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              GET A QUOTE
            </button>
          </div>

        </div>

      </section>

      {/* Final CTA Section End */}
     
    </>
  );
}

export default Home;
